import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute, {
  CompanyRequiredRoute,
  DisplayNameRequiredRoute,
} from './components/auth/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import KakaoCallbackPage from './pages/KakaoCallbackPage';
import SetupProfilePage from './pages/SetupProfilePage';
import CompanySelectPage from './pages/CompanySelectPage';
import DashboardPage from './pages/DashboardPage';
import ApprovalDetailPage from './pages/ApprovalDetailPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/oauth/kakao/authorize/fallback"
          element={<KakaoCallbackPage />}
        />
        <Route element={<ProtectedRoute />}>
          <Route path="/setup-profile" element={<SetupProfilePage />} />
          <Route element={<DisplayNameRequiredRoute />}>
            <Route path="/companies" element={<CompanySelectPage />} />
            <Route element={<CompanyRequiredRoute />}>
              <Route path="/app" element={<DashboardPage />} />
              <Route path="/approvals/:requestId" element={<ApprovalDetailPage />} />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
